import React, { forwardRef, useImperativeHandle, useState, useEffect } from 'react';
import DeleteIcon from '../../static/image/deleteIcon.svg';
import closeIcon from '../../static/image/close.svg'
import CustomInput from '../../components/customInput/CustomInput';
import CommonDeleteModal from '../../components/commonDeleteModal/CommonDeleteModal';

import ModalFileUpload from '../../components/ModalFileUpload/ModalFileUpload';
import { useDispatch } from 'react-redux';
import { uploadAsset, deleteAsset } from '../../redux/assetSlice';
import { ASSET_LOCATION_MAPPING, ASSET_TYPE_MAPPING } from '../../utils/constant';

import { fetchIndustryContent } from '../../redux/homePageSlice';

const TrustedPartners = forwardRef(({ language, onShowAlert = () => { } }, ref) => {
  const dispatch = useDispatch();
  const [titles, setTitles] = useState(['']);
  const [description, setDescription] = useState('');
  const [items, setItems] = useState([
    {
      iconUrl: "",
      description: "",
      width: "",
      height: ""
    }
  ]);

  const [showDeleteItemModal, setShowDeleteItemModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [titleToDelete, setTitleToDelete] = useState(null);
  const [showDeleteTitleModal, setShowDeleteTitleModal] = useState(false);

  const [showFileUploadModal, setShowFileUploadModal] = useState(false);
  const [selectedItemIndex, setSelectedItemIndex] = useState(null);
  const [selectedField, setSelectedField] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [isShowDeleteAsset, setIsShowDeleteAsset] = useState(null);

  useEffect(() => {
    if (language) {
      dispatch(fetchIndustryContent({
        language,
        page: 'trustedPartners',
        region: 'SG',
        type: 'homePage'
      }))
        .then((result) => {
          if (result.payload) {
            const contentData = result.payload.resdata?.contentData;

            if (contentData) {
              if (contentData.titles && contentData.titles.length > 0) {
                setTitles(contentData.titles);
              }
              setDescription(contentData.description || '');

              if (contentData.items && contentData.items.length > 0 && contentData.items[0].row) {
                setItems(contentData.items[0].row);
              }
            }
          }
        })
        .catch((error) => {
          console.error('Failed to fetch trusted partners:', error);
        });
    }
  }, [language, dispatch]);

  const PLACEHOLDER_CONFIG = {
    title: {
      EN: "Enter title in EN",
      CN: "Enter title in CN"
    },
    description: {
      EN: "Enter description in EN",
      CN: "Enter description in CN"
    },
    iconUrl: {
      EN: "Enter icon URL",
      CN: "Enter icon URL"
    },
    itemDescription: {
      EN: "Enter description in EN",
      CN: "Enter description in CN"
    },
    width: {
      EN: "Enter width",
      CN: "Enter width"
    },
    height: {
      EN: "Enter width",
      CN: "Enter width"
    }
  };

  const addGroup = () => {
    setItems([
      ...items,
      {
        iconUrl: "",
        description: "",
        width: "",
        height: ""
      }
    ]);
  };

  const addTitleInput = () => {
    setTitles([...titles, '']);
  };

  const handleShowDeleteTitle = (index) => {
    if (titles.length <= 1) {
      alert('At least retain one title');
      return;
    }
    setTitleToDelete(index);
    setShowDeleteTitleModal(true);
  };

  const handleConfirmDeleteTitle = () => {
    if (titleToDelete !== null) {
      const newTitles = titles.filter((_, i) => i !== titleToDelete);
      setTitles(newTitles);
    }
    setShowDeleteTitleModal(false);
    setTitleToDelete(null);
  };

  const handleShowDeleteItem = (index) => {
    if (items.length <= 1) {
      alert('At least retain one partner item');
      return;
    }
    setItemToDelete(index);
    setShowDeleteItemModal(true);
  };

  const handleConfirmDeleteItem = () => {
    if (itemToDelete !== null) {
      const newItems = items.filter((_, i) => i !== itemToDelete);
      setItems(newItems);
    }
    setShowDeleteItemModal(false);
    setItemToDelete(null);
  };

  const updateItem = (index, field, value) => {
    const newItems = items.map((item, i) =>
      i === index ? { ...item, [field]: value } : item
    );
    setItems(newItems);
  };

  const updateTitle = (index, value) => {
    const newTitles = [...titles];
    newTitles[index] = value;
    setTitles(newTitles);
  };

  const updateDescription = (value) => {
    setDescription(value);
  };

  const validateAllItems = () => {
    return {};
  };

  const handleShowUploadFile = (itemIndex, field) => {
    setSelectedItemIndex(itemIndex);
    setSelectedField(field);
    setShowFileUploadModal(true);
  };

  const handleShowDeleteFile = (itemIndex, field) => {
    setSelectedItemIndex(itemIndex);
    setSelectedField(field);
    setIsShowDeleteAsset(true);
  };

  const handleCancelUploadFile = () => {
    setShowFileUploadModal(false);
    setSelectedItemIndex(null);
    setSelectedField(null);
    setIsUploading(false);
  };

  const handleFileUpload = (file) => {
    if (!file) return;

    setIsUploading(true);

    const formData = new FormData();
    formData.append("file", file);
    formData.append("assetLocation", "TrustedPartners");
    formData.append("assetType", ASSET_TYPE_MAPPING.homePage);

    dispatch(uploadAsset(formData))
      .then((res) => {
        if (res?.payload) {
          const fileUrl = res.payload.resdata.url;

          const newItems = items.map((item, i) =>
            i === selectedItemIndex ? { ...item, [selectedField]: fileUrl } : item
          );

          setItems(newItems);
        }
        if (res?.error) {
          onShowAlert(res.error.message, false);
        }
      })
      .catch((err) => {
        onShowAlert(err.message || "Upload failed", false);
      })
      .finally(() => {
        setIsUploading(false);
        setShowFileUploadModal(false);
        setSelectedItemIndex(null);
        setSelectedField(null);
      });
  };

  const handleDeleteFile = () => {
    const fileUrl = items[selectedItemIndex]?.iconUrl;
    const fileId = fileUrl ? fileUrl.split('/').pop().split('.')[0] : null;
    const newItems = items.map((item, i) =>
      i === selectedItemIndex ? { ...item, [selectedField]: "" } : item
    );

    setItems(newItems);

    if (fileId) {
      dispatch(deleteAsset(fileId))
        .then((res) => {
          if (res?.error) {
            onShowAlert(res.error.message, false);
          }
        })
        .catch((err) => {
          onShowAlert(err.message, false);
        });
    }

    setIsShowDeleteAsset(null);
    setSelectedItemIndex(null);
    setSelectedField(null);
  };

  useImperativeHandle(ref, () => ({
    addGroup,
    addTitleInput,
    validateAllItems,
    getData: () => ({
      titles,
      description,
      items: [
        {
          row: items
        }
      ]
    })
  }));

  const renderFileUploadSection = (item, index) => (
    <div className='package-input'>
      <label>Icon:</label>
      <input
        type="text"
        placeholder={PLACEHOLDER_CONFIG.iconUrl[language]}
        value={item.iconUrl || ''}
        disabled
        style={{ width: '73%' }}
      />
      {!item.iconUrl ? (
        <button
          className="upload-btn"
          onClick={() => handleShowUploadFile(index, "iconUrl")}
        >
          Upload
        </button>
      ) : (
        <button
          className="icon-btn"
          onClick={() => handleShowDeleteFile(index, "iconUrl")}
        >
          <img src={DeleteIcon} alt="Delete" className="action-icon" />
        </button>
      )}
    </div>
  );

  return (
    <div className="tab-package-container">
      <div className="domain-group">
        {titles.map((title, index) => (
          <div className='package-input' key={index}>
            {index === 0 ? (
              <>
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: '8px'
                }}>
                  <label>Title:</label>

                </div>
                <CustomInput
                  type="text"
                  value={title || ''}
                  onChange={(e) => updateTitle(index, e.target.value)}
                  placeholder={PLACEHOLDER_CONFIG.title[language]}
                  customStyle={{ width: '73%' }}
                />
                {titles.length > 1 && (
                  <button
                    className="icon-btn"
                    onClick={() => handleShowDeleteTitle(index)}

                  >
                    <img
                      src={closeIcon}
                      alt="Delete Title"
                      className="trusted-delete-icon"

                    />
                  </button>
                )}
              </>
            ) : (
              <>
                <div className='package-input'>
                  <div style={{ width: '20px' }}></div>

                </div>
                <CustomInput
                  type="text"
                  value={title || ''}
                  onChange={(e) => updateTitle(index, e.target.value)}
                  placeholder={`${PLACEHOLDER_CONFIG.title[language]} ${index + 1}`}
                  customStyle={{ width: '73%', marginLeft: '160px' }}
                />
                <button
                  className="icon-btn"
                  onClick={() => handleShowDeleteTitle(index)}

                >
                  <img
                    src={closeIcon}
                    alt="Delete Title"
                    className="trusted-delete-icon"

                  />
                </button>
              </>
            )}
          </div>
        ))}

        {titles.length > 0 && (
          <div style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '10px'
          }}>
            <button
              onClick={addTitleInput}
              className="package-add-btn"
            >
              <span>Add New</span>
            </button>
          </div>
        )}

        <div className='package-input' style={{ marginTop: '20px' }}>
          <label>Description:</label>
          <textarea
            placeholder={PLACEHOLDER_CONFIG.description[language]}
            value={description || ''}
            onChange={(e) => updateDescription(e.target.value)}
            rows={4}
          />
        </div>
      </div>

      <div
        style={{
          height: '0.5px',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          margin: '25px -40px',
          width: 'calc(100% + 80px)',
          display: 'block',
          boxSizing: 'border-box'
        }}
      />

      {items.map((item, index) => (
        <div key={index}>
          <div className="domain-group">

            <div className='package-input'>
              <label>Description:</label>
              <textarea
                placeholder={PLACEHOLDER_CONFIG.itemDescription[language]}
                value={item.description || ''}
                onChange={(e) => updateItem(index, 'description', e.target.value)}
                rows={4}
              />
              <button
                className="icon-btn"
                onClick={() => handleShowDeleteItem(index)}
              >
                <img src={DeleteIcon} alt="Delete" className="campaign-delete-icon" />
              </button>
            </div>
            {renderFileUploadSection(item, index)}

            {item.iconUrl && (
              <div style={{ marginLeft: '190px', marginBottom: '20px' }}>
                <img
                  src={`https://uat.stack-ez.com${item.iconUrl}`}
                  alt="Preview"
                  style={{ maxWidth: '200px', maxHeight: '200px', marginTop: '10px' }}
                />
              </div>
            )}

            <div className='package-input'>
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '8px'
              }}>
                <label>
                  Width:
                </label>
              </div>
              <CustomInput
                type="text"
                value={item.width || ''}
                onChange={(e) => updateItem(index, 'width', e.target.value)}
                placeholder={PLACEHOLDER_CONFIG.width[language]}
                customStyle={{ width: '73%' }}
              />
            </div>

            <div className='package-input'>
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '8px'
              }}>
                <label>
                  Height:
                </label>
              </div>
              <CustomInput
                type="text"
                value={item.height || ''}
                onChange={(e) => updateItem(index, 'height', e.target.value)}
                placeholder={PLACEHOLDER_CONFIG.height[language]}
                customStyle={{ width: '73%' }}
              />
            </div>
          </div>

          {index !== items.length - 1 && (
            <div
              style={{
                height: '0.5px',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                margin: '25px -40px',
                width: 'calc(100% + 80px)',
                display: 'block',
                boxSizing: 'border-box'
              }}
            />
          )}
        </div>
      ))}

      <ModalFileUpload
        show={showFileUploadModal}
        handleCancel={handleCancelUploadFile}
        handleUpload={handleFileUpload}
        isLoading={isUploading}
      />

      <CommonDeleteModal
        show={!!isShowDeleteAsset}
        onHide={() => setIsShowDeleteAsset(null)}
        onConfirm={handleDeleteFile}
        title="Delete Asset"
        instruction="Are you sure you want to delete this asset?"
      />

      <CommonDeleteModal
        show={showDeleteTitleModal}
        onHide={() => {
          setShowDeleteTitleModal(false);
          setTitleToDelete(null);
        }}
        onConfirm={handleConfirmDeleteTitle}
        title="Delete Title"
        instruction="Are you sure you want to delete this title?"
      />

      <CommonDeleteModal
        show={showDeleteItemModal}
        onHide={() => {
          setShowDeleteItemModal(false);
          setItemToDelete(null);
        }}
        onConfirm={handleConfirmDeleteItem}
        title="Delete Partner Item"
        instruction="Are you sure you want to delete this partner item?"
      />
    </div>
  );
});

export default TrustedPartners;